import {Content, LoadingButton, useBreakPoints, useTranslation} from '@hconnect/uikit'
import {PageHeader} from '@hm/fundamental'
import {ArrowForward} from '@mui/icons-material'
import {Box, Grid, Paper} from '@mui/material'
import React from 'react'
import {useFormContext} from 'react-hook-form'
import {useHistory} from 'react-router'

import {useAllowedHConnectConfigCountries} from '../../hooks/useAllowedHConnectConfigCountries'
import {useStyles} from '../../OrderManagement/components/OrderManagementConfigurationDetails.styles'
import {OrderCancellationConfig} from '../types/OrderCancellationConfig'

import {OrderCancellationConstraints} from './OrderCancellationConstraints'
import {OrderCancellationLeadTimes} from './OrderCancellationLeadTimes'

type Props = {
  configId?: string
  onSaveButtonClick: () => void
  isSubmitting: boolean
}

export const OrderCancellationConfigurationDetails = ({onSaveButtonClick, isSubmitting}: Props) => {
  const {t} = useTranslation()
  const screenSizes = useBreakPoints()
  const isMobile = ['xs', 'sm'].includes(screenSizes)
  const isTablet = ['xs', 'sm', 'md'].includes(screenSizes)
  const {classes} = useStyles({isMobile})
  const history = useHistory()

  const configurableHConnectCountries = useAllowedHConnectConfigCountries()

  const handleFieldChange = (dayOfWeek: string, field: string, value: string | boolean) => {
    const currentBusinessDays = formMethods.getValues('businessDays')
    const newBusinessDays = [...currentBusinessDays]
    const index = newBusinessDays.findIndex((day) => day.dayOfWeek === dayOfWeek)
    if (index !== -1) {
      newBusinessDays[index] = {
        ...newBusinessDays[index],
        [field]: field === 'cancellationLeadTime' ? Number(value) : value
      }
    }
    formMethods.setValue('businessDays', newBusinessDays)
  }

  const formMethods = useFormContext<OrderCancellationConfig>()

  const businessDays = formMethods?.watch('businessDays')

  if (!businessDays) {
    return <div>{t('configurations.hconnect.orderCancellation.configurationDetails.loading')}</div>
  }

  return (
    <Content>
      <div className="[&_*]:!text-white">
        <PageHeader
          className="pl-0 pr-0 md:pl-0 md:pr-0"
          backToPageLabel={
            isTablet
              ? t('configurations.hconnect.orderCancellation.configurationDetails.title')
              : t('configurations.hconnect.orderCancellation.configurationDetails.goBack')
          }
          backToPageUrlOnClick={() => history.goBack()}
        >
          {t('configurations.hconnect.orderCancellation.configurationDetails.title')}
        </PageHeader>
      </div>

      <Grid container className={classes.gridContainer} spacing={2}>
        <Grid item lg={3} md={3} sm={12} xs={12} className={classes.gridItem}>
          <Paper elevation={4} className={classes.paper}>
            <OrderCancellationConstraints countries={configurableHConnectCountries} />
          </Paper>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className={classes.gridItem}>
          <Paper elevation={4} className={classes.paper}>
            <OrderCancellationLeadTimes
              businessDays={businessDays}
              handleFieldChange={handleFieldChange}
            />
            <Box className={classes.saveButtonBox}>
              <LoadingButton
                startIcon={<ArrowForward fontSize="small" />}
                variant="outlined"
                color="primary"
                style={{background: 'rgb(1, 106, 212', textTransform: 'none'}}
                onClick={onSaveButtonClick}
                loading={isSubmitting}
                data-test-id="order-cancellation-configuration-save-button"
              >
                {t('configurations.hconnect.orderCancellation.configurationDetails.buttonSave')}
              </LoadingButton>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Content>
  )
}
